module.exports = __webpack_public_path__ + "img/success.70eb1272.svg";